import { Config } from "../config/config";

export const baseUrl = Config.apiRoot;

export const partnersRoute = baseUrl + "partners";
export const usersRoute = baseUrl + "users";
export const citiesRoute = baseUrl + "cities";
export const rolesRoute = baseUrl + "roles";
export const warehousesRoute = baseUrl + "warehouses";
export const productsRoute = baseUrl + "products";
export const productCategoriesRoute = baseUrl + "productCategories";
export const productReservationsRoute = baseUrl + "productReservations";
export const ownershipDocumentsRoute = baseUrl + "ownershipDocuments";
export const settingsRoute = baseUrl + "settings";
export const auditLogRoute = baseUrl + "audit-log";

export const oneDocumentRoute = baseUrl + "productInputs";
export const oneDocumentVirtualWarehouseRoute = oneDocumentRoute + "/virtual-repromaterial";
export const documentsRoute = baseUrl + "productInputs/new-version";
export const prevRequestsRoute = baseUrl + "requests";
export const requestsRoute = baseUrl + "requests/new-version";
export const dispositionsRoute = baseUrl + "dispositions";
export const dispositionsByRequestRoute = dispositionsRoute + "/new-version";
export const dispositionsByDateRoute = dispositionsRoute + "/all-dispositions";
export const dispositionsByDateProductInputRoute =
  dispositionsRoute + "/all-dispositions-product-input";
export const requestsByDateRoute = baseUrl + "requests/all-requests";
export const servicedMeasurementsRoute = baseUrl + "serviced-measurement";
export const virtualReproWarehouseRoute = baseUrl + "virtual-warehouse";

export const registrationNumbersRoute =
  baseUrl + "dispositions/mobile/registration-number/all";
export const driverNamesRoute =
  baseUrl + "dispositions/mobile/drivers-name/all";

// DORADNI CENTAR
export const processingRequestsRoute = baseUrl + "dorada/requests";
export const processingDispositionsRoute = baseUrl + "dorada/dispositions";
export const processingOrdersRoute = baseUrl + "dorada/orders";
export const operatorOrdersRoute = baseUrl + "dorada/operator-orders";
export const processingLogsRoute = baseUrl + "dorada/logs";
export const declarationsRoute = baseUrl + "dorada/declarations";

// STOCK BALANCE (stanja)
export const stockBalanceRoute = baseUrl + "stock-balance";
export const stockBalanceSyncRoute = stockBalanceRoute + "/sync"; // /:year

// FORME / brza stanja
export const stockBalanceMercantileAvailableRoute =
  stockBalanceRoute + "/mercantile/available";
export const stockBalanceReproAvailableSalesRoute =
  stockBalanceRoute + "/repro/available-sales";
export const stockBalanceOnHandRoute = stockBalanceRoute + "/on-hand";
